import Cleave from 'cleave.js/react';
import PropTypes from 'prop-types';
import React from 'react';
import { ThemedTextField } from 'common/styles';

function ZipFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <Cleave
            {...other}
            htmlRef={inputRef}
            options={{blocks: [5], numericOnly: true}}
            onChange={onChange}
        />
    );
}

ZipFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired
};

export default function ZipField(props) {
    return (
        <ThemedTextField
            {...props}
            type="text"
            InputProps={{ inputComponent: ZipFormatCustom }}
        />
    );
}
